import { createContext, useContext } from 'react';

export interface NavContextInterface {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
  toggleCollapse: () => void;
  isMobileNavOpen: boolean;
  toggleMobileNav: () => void;
  isDrillInOpen: boolean;
  setIsDrillInOpen: (isOpen: boolean) => void;
}

export const NavContext = createContext<NavContextInterface>({
  isCollapsed: false,
  setIsCollapsed: () => {},
  toggleCollapse: () => {},
  isMobileNavOpen: false,
  toggleMobileNav: () => {},
  isDrillInOpen: false,
  setIsDrillInOpen: () => {},
});

export function useNavContext(): NavContextInterface {
  return useContext(NavContext);
}
